module.exports = __webpack_public_path__ + "static/media/raspi.2366b6cc.md";